import {Navbar} from "@project/design-system-web";
import {useI18n} from "@project/i18n/react";
import {BellIcon, SearchIcon} from "@project/icons-web";

import {appShellMessages} from "../../../messages/app-shell.messages";
import {MobileExtensionButton} from "../right-sidebar/mobile-extension-button";

export function AppHeaderActions() {
  const {t} = useI18n();

  return (
    <Navbar.Content className="shrink-0">
      <Navbar.Item aria-label={t(appShellMessages.search)}>
        <SearchIcon className="size-4" />
      </Navbar.Item>

      <Navbar.Item aria-label={t(appShellMessages.notifications)}>
        <BellIcon className="size-4" />
      </Navbar.Item>

      <Navbar.Separator className="lg:hidden" />

      <div className="lg:hidden">
        <MobileExtensionButton />
      </div>
    </Navbar.Content>
  );
}
